// extracted by mini-css-extract-plugin
export default {"vmw":"Landing_vmw__MEFXv","vmwdiv":"Landing_vmwdiv__1GiIE","frontdiv":"Landing_frontdiv__xAftW","main1":"Landing_main1__8EL3v","myVideoDiv":"Landing_myVideoDiv__VRFk9"};